module.exports = __webpack_public_path__ + "static/media/create.60aa4216.png";